import React from 'react';
import AnimationContext from './AnimationState.js';
import SearchState from './SearchState.js';
import useShuttleState from './ShuttleState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';
import '@babel/runtime/helpers/esm/toConsumableArray';
import './helper.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';
import './Shuttle.actions.js';
import './utils.js';

/* eslint-disable react/display-name */

function withProviders(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(useShuttleState.Provider, null, /*#__PURE__*/React.createElement(AnimationContext.Provider, null, /*#__PURE__*/React.createElement(SearchState.Provider, null, /*#__PURE__*/React.createElement(Component, props))));
  };
}

export default withProviders;
//# sourceMappingURL=withProviders.js.map
